import axios from '@/utils/http'

export function login (parameter) {
  return axios({
    url: '/AccountService/Account/PCLogin',
    method: 'post', // default
    data: {
      ...parameter
    }
  })
}
